$(document).ready(function(){

    jQuery(function($) {

        jQuery('input[name=pim_all_products]').change(function()
        {
            updatePimProductsStatus();
        });

        function updatePimProductsStatus()
        {
            if(jQuery('#pim_all_products__select_groups').is(':checked'))
            {
                enablePimTagsAndCats();
            } else {
                disablePimTagsAndCats();
            }
        }

        function enablePimTagsAndCats()
        {
                $('#select-deselect-ug-pim-tags').prop('disabled', false);
                $('#select-deselect-ug-pim-cats').prop('disabled', false);
                $('.pim-panel-checklist input').prop('disabled', false);
        }

        function disablePimTagsAndCats()
        {
                $('#select-deselect-ug-pim-tags').prop('disabled', true);
                $('#select-deselect-ug-pim-cats').prop('disabled', true);
                $('.pim-panel-checklist input').prop('disabled', true);
        }

        $('#select-deselect-ug-pim-tags').click(function() {
            var anyUnchecked = $('.ug-pim-tags input[type="checkbox"]:not(:checked)').length > 0;
            $('.ug-pim-tags input[type="checkbox"]').prop('checked', anyUnchecked).change();
        });
        $('#select-deselect-ug-pim-cats').click(function() {
            var anyUnchecked = $('.ug-pim-cats input[type="checkbox"]:not(:checked)').length > 0;
            $('.ug-pim-cats input[type="checkbox"]').prop('checked', anyUnchecked).change();
        });

        updatePimProductsStatus();

    });

});